import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { IUser } from '../../interfaces';
import { AuthService, LanguageService } from '../../services';
import { UserPanelModule } from '../user-panel/user-panel.component';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  user: IUser | null = null;

  userMenuItems = [
    // {
    //   text: 'Kilépés',
    //   icon: 'runner',
    //   onClick: () => {
    //     this.user = null;
    //     this.authService.logOut();
    //   },
    // }
  ];

  lang!: string;
  languages!: string[];

  constructor(private router: Router, private authService: AuthService, public languageService: LanguageService) {}

  ngOnInit() {
    this.authService.getUser().then((e) => (this.user = e.data));
    this.lang = this.languageService.language;
    this.languages = this.languageService.languages;
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  };

  activeLangguage(lang: string): boolean {
    return this.lang === lang;
  }

  changeLanguage(lang: string): void {
    if (this.languageService.language === lang) return;

    this.languageService.changeLanguage(lang);
  }

  navigateToReports = (): void => {
    this.router.navigate(['reports']);
  };

  isAuthentecated(): boolean {
    return this.authService.loggedIn;
  }

  clickedHelp = () => {
    this.authService.location('/help').then((e) => {} );
  }
}

@NgModule({
  imports: [CommonModule, DxButtonModule, UserPanelModule, DxToolbarModule],
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
})
export class HeaderModule {}
